import React, { useEffect, useState, Component } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../../TableView";
import { set } from "react-hook-form";

const BookingInfo = (
  props,
  {
    handleChange,
    selectedBookingItem,
    onhandleBookingNunber,
    onhadleBLnumber,
    onhadleBookingDate,
    onhadleBLNO,
    onhadleSalesPerson,
    onhadleJobtype,
    onhadleIncotermdes,
    onhadleTotalVol,
    onhadlePol,
    onhadlePod,
    onhadleEtaEtdDate,
    onhadleVessel,
    onhadleVoyage,
    onhadleRemark,
    onhadleIsFCL,
    onhadleTransType,
    onhadleCarriercode,
    onhadleShipType,
    onhadleIntercom,
  }
) => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [baseUrl, setBaseUrl] = useState("https://devmol.evolve-demo.com/api/");
  // const [baseUrl, setBaseUrl] = useState("http://mol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("booking_costing");
  const [bookingNOList, setBookingNOList] = useState(undefined);
  const [tranModeList, setTranModeList] = useState(undefined);
  const [jobTypeList, setJobTypeList] = useState(undefined);
  const [incotermsList, setIncotermsList] = useState(undefined);
  const [polList, setPolList] = useState(undefined);
  const [podList, setPodList] = useState(undefined);
  const [vesselList, setVesselList] = useState(undefined);
  const [voyageList, setVoyageList] = useState(undefined);
  const [salesPersonList, setSalesPersonList] = useState(undefined);
  const [booking, setBooking] = useState(undefined);
  const [bookindNo, setBookindNo] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const [bLNO, setBLNO] = useState("");
  const [jobtype, setJobtype] = useState("");
  const [incotermdes, setIncoterm] = useState("");
  const [totalVol, setTotalVol] = useState("");
  const [pol, setPol] = useState("");
  const [pod, setPod] = useState("");
  const [etaEtdDate, setEtaEtdDate] = useState("");
  const [vessel, setVessel] = useState("");
  const [voyage, setVoyage] = useState("");
  const [remark, setRemark] = useState("");
  const [carriercode, setCarriercode] = useState("");
  const [salesPerson, setSalesPerson] = useState("");
  const [shipType, setShipType] = useState("");
  const [isLCL, setIsLCL] = useState(false);
  const [isFCL, setIsFCL] = useState(false);
  const [transType, setTransType] = useState("");
  const [intercom, setIntercom] = useState("");
  const [emptyBookingNUmber, setEmptyBookingNUmber] = useState(false);
  const [emptyTransMode, setEmptyTransMode] = useState(false);
  const [emptyBKDate, setEmptyBKDate] = useState(false);
  const [emptyJBType, setEmptyJBType] = useState(false);
  const [emptyIntercom, setEmptyIntercom] = useState(false);
  const [emptyTotVal, setEmptyTotVal] = useState(false);
  const [emptyPOL, setEmptyPOL] = useState(false);
  const [emptyPOD, setEmptyPOD] = useState(false);
  const [emptyVessel, setEmptyVessel] = useState(false);
  const [emptyETAETD, setEmptyETAETD] = useState(false);
  const [emptyVoyage, setEmptyVoyage] = useState(false);
  const [emptyRemark, setEmptyRemark] = useState(false);
  const [emptyCCCode, setEmptyCCCode] = useState(false);
  const [emptyBL, setEmptyBL] = useState(false);
  const [emptySLP, setEmptySLP] = useState(false);

  const passBookingNUM = (value) => {
    setBookindNo(value);
    // onhandleBookingNunber(value);
    props.callParentFunction(value);
  };

  const psassBLNumber = (BLNumber) => {
    setBLNO(BLNumber);
    onhadleBLnumber(BLNumber);
    onhadleBLNO(BLNumber);
  };

  const valueToTransType = (event) => {
    props.onhandletransTypeCode(event.target.value);
    setTransType(event.target.value);
    // tranModeList.forEach((transitem) => {
    //   if (transitem.TranModCode == event.target.value) {
    //     props.onhandletransTypeDesc(transitem.TranModDesc);
    //   }
    // });
  };

  const valueToBookingDate = (event) => {
    props.handleChangeBookingDate(event.target.value);
    setBookingDate(event.target.value);
  };

  const valueToJobType = (event) => {
    props.onhandlejobtypeCode(event.target.value);
    setJobtype(event.target.value);
    jobTypeList.forEach((jobitem) => {
      if (jobitem.id == event.target.value) {
        props.onhandlejobtypeDesc(jobitem.job_description);
      }
    });
  };

  const valueToIntercom = (event) => {
    props.onhandleIncotermCode(event.target.value);
    setIncoterm(event.target.value);
    incotermsList.forEach((temItem) => {
      if (temItem.TermCode == event.target.value) {
        props.onhandleIncotermDesc(temItem.TermDesc);
      }
    });
  };

  const valueToTotalVolume = (event) => {
    props.handleChangeTotalVolume(event.target.value);
    setTotalVol(event.target.value);
  };

  const valueToPOL = (event) => {
    props.onhandlePOLCode(event.target.value);
    setPol(event.target.value);
    polList.forEach((pol) => {
      if (pol.id == event.target.value) {
        props.onhandlePOLDesc(pol.port_description);
      }
    });
  };

  const valueToPOD = (event) => {
    props.onhandlePODCode(event.target.value);
    setPod(event.target.value);
    if (podList !== undefined) {
      podList.pod.forEach((pol) => {
        if (pol.id == event.target.value) {
          props.onhandlePODDesc(pol.port_description);
        }
      });
    }
  };

  const valueToETAETDhadle = (event) => {
    props.handleChangeETAETD(event.target.value);
    setEtaEtdDate(event.target.value);
  };

  const valueToVessel = (event) => {
    props.onhandleVesselCode(event.target.value);
    setVessel(event.target.value);
    if (vesselList !== undefined) {
      vesselList.forEach((vesItem) => {
        if (vesItem.VesselCode == event.target.value) {
          props.onhandleVesselDesc(vesItem.VesselDesc);
        }
      });
    }
  };

  const valueToVoyage = (event) => {
    props.onhandleVoyageCode(event.target.value);
    setVoyage(event.target.value);
    if (voyageList !== undefined) {
      voyageList.forEach((voyItem) => {
        if (voyItem.VesselCode == event.target.value) {
          props.valueToVoyageDesc(voyItem.VesselDesc);
        }
      });
    }
  };

  const valueToRemarkhadle = (event) => {
    props.handleChangeRemark(event.target.value);
    setRemark(event.target.value);
  };

  const valueToCarrierCodehadle = (event) => {
    props.handleChangeCarrierode(event.target.value);
    setCarriercode(event.target.value);
  };

  const valueToBLNOhadle = (event) => {
    props.handleChangeBLNO(event.target.value);
    setBLNO(event.target.value);
  };

  const valueSalesPersonHadle = (event) => {
    props.onhandleSalesPersonCode(event.target.value);
    setSalesPerson(event.target.value);
    if (salesPersonList !== undefined) {
      salesPersonList.forEach((saleman) => {
        if (saleman.SPCode == event.target.value) {
        }
      });
    }
  };

  const passTransType = (transType) => {
    setTransType(transType);
    onhadleTransType(transType);
  };

  const passBookingDate = (bookingDate) => {
    setBookingDate(bookingDate);
    onhadleBookingDate(bookingDate);
  };

  const passIntercom = (intercom) => {
    setIntercom(intercom);
    onhadleIncotermdes(intercom);
  };

  const passTotalVol = (totVal) => {
    setTotalVol(totVal);
    onhadleTotalVol(totalVol);
  };

  const passPol = (pol) => {
    setPol(pol);
    onhadlePol(pol);
  };

  const passPod = (pod) => {
    setPod(pod);
  };

  const passEtaEtdDate = (etaDate) => {
    setEtaEtdDate(etaDate);
    onhadleEtaEtdDate(etaEtdDate);
  };

  const passVessel = (vessel) => {
    setVessel(vessel);
    onhadleVessel(vessel);
  };

  const passVoyage = (voyage) => {
    setVoyage(voyage);
    onhadleVoyage(voyage);
  };

  const passRemark = (remark) => {
    setRemark(remark);
    onhadleRemark(remark);
  };

  const passCarriercode = (carriercode) => {
    setCarriercode(carriercode);
    onhadleCarriercode(carriercode);
  };

  const passSalesPerson = (salesperson) => {
    setSalesPerson(salesperson);
    onhadleSalesPerson(salesPerson);
  };

  const handleFCL = (event) => {
    setIsFCL(event.target.checked);

    if (event.target.checked == true) {
      // setShipType("FCL");
      // onhadleIsFCL(isFCL);
      props.handleChangeShipType("FCL");
    }

    // props.hadleShipType(shipType);
  };
  //FCL, LCL , F/L
  const handleLCL = (event) => {
    setIsLCL(event.target.checked);

    if (event.target.checked == true) {
      // setShipType("LCL");
      props.handleChangeShipType("LCL");
    }
    // props.hadleShipType(shipType);
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setBookingNOList(data.booking_header);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  const setBookingItem = (value) => {
    console.log(value);
    setBookindNo(value);
    let curruntBookingNo = value;
    booking.forEach((bookingItem) => {
      if (bookingItem.BookingNo == curruntBookingNo) {
        let bookDate = bookingItem.BookingDate;
        let bookdateOnly = bookDate.slice(0, 10);
        setBookingDate(bookdateOnly);
        setJobtype(bookingItem.JobDesc);
        setBLNO(bookingItem.BLNo);
        setIncoterm(bookingItem.TermDesc);
        setTotalVol(bookingItem.TotalVolume);
        setPol(bookingItem.PortDesc);
        podList.pod.map((podItem, id) =>
          podItem.id == bookingItem.POD ? setPod(podItem.PortDesc) : ""
        );
        let etaEtdDate = bookingItem.EtaEtd;
        let etaEtdDateOnly = etaEtdDate.slice(0, 10);
        setEtaEtdDate(etaEtdDateOnly);
        setVessel(bookingItem.VesselDesc);
        setVoyage(bookingItem.VoyDesc);
        setRemark(bookingItem.Remark);
        setCarriercode(bookingItem.CarrierCode);
        setSalesPerson(bookingItem.SPName);
        if (bookingItem.ShipmentType == "FCL") {
          setIsFCL(true);
        } else if (bookingItem.ShipmentType == "LCL") {
          setIsLCL(true);
        }
      }
    });
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/index`)
      .then((response) => response.json())
      .then((data) => {
        setBooking(data.booking);
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getsalesperson`)
      .then((response) => response.json())
      .then((data) => {
        setSalesPersonList(data.salesperson);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getvoyage`)
      .then((response) => response.json())
      .then((data) => {
        setVoyageList(data.voyage);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getvessel`)
      .then((response) => response.json())
      .then((data) => {
        setVesselList(data.vessels);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/transmodedropdown`)
      .then((response) => response.json())
      .then((data) => {
        setTranModeList(data.transmode);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}job_types/dropdown`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setJobTypeList(data.job_types);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}incoterms/dropdown`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIncotermsList(data.incoterms);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}ports/dropdown`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setPolList(data.ports);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/poddropdown`)
      .then((response) => response.json())
      .then((data) => {
        setPodList(data);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  const handleContainer = () => {
    const inputNOSData = {
      BookingDate: bookingDate,
      CarrierCode: carriercode,
      BLNo: bLNO,
      TranModCode: 1,
      JobCode: 4,
      SPCode: 1,
      TermCode: 2,
      VesCode: 3,
      VoyCode: 4,
      TotalVolume: totalVol,
      POL: 2,
      POD: 3,
      EtaEtd: etaEtdDate,
      ShipmentType: shipType,
      TotalNBT: 500,
      TotalVAT: 500,
      TotalNBTQuote: 500,
      TotalVATQoute: 500,
      TotalCost: 500,
      TotalQuote: 500,
      Difference: 1000,
      CreditDays: 5,
      Remark: remark,
    };
    axios
      .post(`${baseUrl}${pageComponent}/store`, inputNOSData)
      .then((response) => {
        console.log(response.data);
        window.location.reload(false);
        alert("Successfully Save Data");
      })
      .catch((error) => {
        console.error(error);
        alert(error);
      });
  };

  return (
    <div className="d-flex flex-column ">
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Booking No </Form.Label>
            <Form.Select
              aria-label="Default select"
              className={emptyBookingNUmber == true ? "border-red2" : ""}
              value={bookindNo}
              onChange={(e) => passBookingNUM(e.target.value)}
            >
              <option value=""></option>
              {bookingNOList !== undefined
                ? bookingNOList.map((bookingItem, id) => (
                    <option value={bookingItem.id} key={id}>
                      {bookingItem.booking_number}
                    </option>
                  ))
                : ""}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Transport Mode </Form.Label>

            <Form.Select
              aria-label="Default select"
              className={emptyTransMode == true ? "border-red2" : ""}
              value={transType}
              onChange={valueToTransType}
            >
              <option value="1">SEA</option>
              <option value="2">AIR</option>
              <option value="3">LAND</option>
              {/* {props.valueTotransTypeCode ? (
                <option value={props.valueTotransTypeCode}>
                  {props.valueTotransTypeDesc}
                </option>
              ) : (
                ""
              )}

              {tranModeList !== undefined
                ? tranModeList.map((tranModeItem, id) => (
                    <option value={tranModeItem.TranModCode} key={id}>
                      {tranModeItem.TranModDesc}
                    </option>
                  ))
                : ""} */}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Booking Date </Form.Label>
            <Form.Control
              type="date"
              placeholder=""
              name="code"
              className={emptyBKDate == true ? "border-red2" : ""}
              value={props.valueToBookingDate}
              onChange={valueToBookingDate}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Type Of Job </Form.Label>
            <Form.Select
              aria-label="Default select"
              className={emptyJBType == true ? "border-red2" : ""}
              value={jobtype}
              onChange={valueToJobType}
            >
              {props.valueTojobtypeCode ? (
                <option value={props.valueTojobtypeCode}>
                  {props.valueTojobtypeDesc}
                </option>
              ) : (
                ""
              )}

              {jobTypeList !== undefined
                ? jobTypeList.map((jobType, id) => (
                    <option value={jobType.id} key={id}>
                      {jobType.job_description}
                    </option>
                  ))
                : ""}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Incoterm </Form.Label>
            <Form.Select
              aria-label="Default select"
              className={emptyIntercom == true ? "border-red2" : ""}
              onChange={valueToIntercom}
            >
              {props.valueToIncotermCode ? (
                <option value={props.valueToIncotermCode}>
                  {props.onhandleIncotermDesc}
                </option>
              ) : (
                ""
              )}

              {incotermdes != "" ? (
                <>
                  {incotermsList !== undefined
                    ? incotermsList.map((incotermsItem, id) => (
                        <option value={incotermsItem.id} key={id}>
                          {incotermsItem.term_description}
                        </option>
                      ))
                    : ""}
                </>
              ) : incotermsList !== undefined ? (
                incotermsList.map((incotermsItem, id) => (
                  <option value={incotermsItem.id} key={id}>
                    {incotermsItem.term_description}
                  </option>
                ))
              ) : (
                ""
              )}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Total Volume</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={props.valueToTotalVolume}
              className={emptyTotVal == true ? "border-red2" : ""}
              name="totvolume"
              onChange={valueToTotalVolume}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>P O L </Form.Label>
            <Form.Select
              aria-label="Default select"
              value={props.valueToPOLCode}
              className={emptyPOL == true ? "border-red2" : ""}
              onChange={valueToPOL}
            >
              {props.valueToPOLCode ? (
                <option value={props.valueToPOLCode}>
                  {props.valueToIPOLDesc}
                </option>
              ) : (
                ""
              )}

              {pol !== "" ? (
                <>
                  {polList !== undefined
                    ? polList.map((polItem, id) => (
                        <option value={polItem.id} key={id}>
                          {polItem.port_description}
                        </option>
                      ))
                    : ""}
                </>
              ) : polList !== undefined ? (
                polList.map((polItem, id) => (
                  <option value={polItem.id} key={id}>
                    {polItem.port_description}
                  </option>
                ))
              ) : (
                ""
              )}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>P O D</Form.Label>
            <Form.Select
              aria-label="Default select "
              value={pod}
              className={emptyPOD == true ? "border-red2" : ""}
              onChange={valueToPOD}
            >
              {props.onhandlePODCode ? (
                <option value={props.valueToPoDCode}>
                  {props.valueToPoDDesc}
                </option>
              ) : (
                ""
              )}

              {pod !== "" ? (
                <>
                  {polList !== undefined
                    ? polList.map((polItem, id) => (
                        <option value={polItem.id} key={id}>
                          {polItem.port_description}
                        </option>
                      ))
                    : ""}
                </>
              ) : polList !== undefined ? (
                polList.map((polItem, id) => (
                  <option value={polItem.id} key={id}>
                    {polItem.port_description}
                  </option>
                ))
              ) : (
                ""
              )}

              {/* {pod !== '' ?
                                <>

                                    {podList !== undefined ? podList.pod.map((poditem, id) => (
                                        <option value={poditem.PortCode} key={id}>{poditem.PortDesc}</option>
                                    )) : ''}

                                </>
                                :
                                podList !== undefined ? podList.pod.map((poditem, id) => (
                                    <option value={poditem.PortCode} key={id}>{poditem.PortDesc}</option>
                                )) : ''

                            } */}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>ETA/ETD</Form.Label>
            <Form.Control
              type="date"
              placeholder=""
              value={props.valueToETAETD}
              name="code"
              className={emptyETAETD == true ? "border-red2" : ""}
              onChange={valueToETAETDhadle}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group
            className="mb-3"
            controlId="formGroupEmail"
            onChange={valueToVessel}
          >
            <Form.Label>
              Vessel {props.valueTosessel} {props.valueToVesselDesc}
            </Form.Label>
            <Form.Select
              aria-label="Default select "
              className={emptyVessel == true ? "border-red2" : ""}
            >
              {props.valueTosessel ? (
                <option value={props.valueTosessel}>
                  {props.valueToVesselDesc}
                </option>
              ) : (
                ""
              )}

              {vessel !== "" ? (
                <>
                  {vesselList !== undefined
                    ? vesselList.map((vesselItem, id) => (
                        <option value={vesselItem.VesselCode} key={id}>
                          {vesselItem.VesselDesc}
                        </option>
                      ))
                    : ""}
                </>
              ) : vesselList !== undefined ? (
                vesselList.map((vesselItem, id) => (
                  <option value={vesselItem.VesselCode} key={id}>
                    {vesselItem.VesselDesc}
                  </option>
                ))
              ) : (
                ""
              )}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Voyage</Form.Label>
            <Form.Select
              aria-label="Default voyage Select"
              value={voyage}
              className={emptyVoyage == true ? "border-red2" : ""}
              onChange={valueToVoyage}
            >
              {props.valueToVyage ? (
                <option value={props.valueToVyage}>
                  {props.valueToVoyage}
                </option>
              ) : (
                ""
              )}

              {voyage !== "" ? (
                <>
                  {voyageList !== undefined
                    ? voyageList.map((voyageItem, id) => (
                        <option value={voyageItem.VoyCode} key={id}>
                          {voyageItem.VoyDesc}
                        </option>
                      ))
                    : ""}
                </>
              ) : voyageList !== undefined ? (
                voyageList.map((voyageItem, id) => (
                  <option value={voyageItem.VoyCode} key={id}>
                    {voyageItem.VoyDesc}
                  </option>
                ))
              ) : (
                ""
              )}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Remark</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={props.valueToRemark}
              className={emptyRemark == true ? "border-red2" : ""}
              name="remark"
              onChange={valueToRemarkhadle}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Carrier Code</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={props.valueToCarrierode}
              className={emptyCCCode == true ? "border-red2" : ""}
              name="carriercode"
              onChange={valueToCarrierCodehadle}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>BL Number</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={props.valueToBLNO}
              className={emptyBL == true ? "border-red2" : ""}
              name="bLNO"
              onChange={valueToBLNOhadle}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="formGroupEmail">
            <Form.Label>Sales Person</Form.Label>
            <Form.Select
              aria-label="default sales person select"
              value={salesPerson}
              className={emptySLP == true ? "border-red2" : ""}
              onChange={valueSalesPersonHadle}
            >
              {props.valueToSalesPersonDesc ? (
                <option value={props.valueToSalesPersonDesc}>
                  {props.valueToSalesPerson}
                </option>
              ) : (
                ""
              )}

              {salesPerson !== "" ? (
                <>
                  {salesPersonList !== undefined
                    ? salesPersonList.map((salespersonItem, id) => (
                        <option value={salespersonItem.SPCode} key={id}>
                          {salespersonItem.SPName}
                        </option>
                      ))
                    : ""}
                </>
              ) : salesPersonList !== undefined ? (
                salesPersonList.map((salespersonItem, id) => (
                  <option value={salespersonItem.SPCode} key={id}>
                    {salespersonItem.SPName}
                  </option>
                ))
              ) : (
                ""
              )}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group className="mb-3 " controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label="FCL"
              checked={isFCL}
              onChange={handleFCL}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="" controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label="LCL"
              checked={isLCL}
              onChange={handleLCL}
            />
          </Form.Group>
        </Col>
        <Col></Col>
        <Col></Col>
        <Col></Col>
        <Col></Col>
        <Col></Col>
        <Col></Col>
      </Row>
      {/* <button className="button" onClick={saveBookingInfo}>show containers</button> */}
    </div>
  );
};

export default BookingInfo;
